import { render } from "./BoiteDesCouleurs1.vue?vue&type=template&id=79ff2684&scoped=true"
import script from "./BoiteDesCouleurs1.vue?vue&type=script&lang=js"
export * from "./BoiteDesCouleurs1.vue?vue&type=script&lang=js"

import "./BoiteDesCouleurs1.vue?vue&type=style&index=0&id=79ff2684&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ff2684"]])

export default __exports__